import * as React from 'react';
import { classes, style } from 'typestyle';
import { regularStyle } from '../../../styles/text';
import { ButtonStyleTypes, stylesSet } from '../../../styles/button';
export var ButtonActionTypes;
(function (ButtonActionTypes) {
    ButtonActionTypes["Reset"] = "reset";
    ButtonActionTypes["Submit"] = "submit";
    ButtonActionTypes["Button"] = "button";
})(ButtonActionTypes || (ButtonActionTypes = {}));
const ButtonAtom = ({ type = ButtonActionTypes.Button, disabled, icon, className, onClick, title, tabIndex, }) => {
    return (React.createElement("button", { disabled: disabled, type: type, className: classes('ta-btn', buttonStyle, regularStyle, icon ? iconedButtonStyle : '', className), onClick: onClick, tabIndex: tabIndex },
        icon && React.createElement("span", { className: classes('ta-btn-icon', iconStyle) }, icon),
        title && React.createElement("span", { className: 'ta-btn-title' }, title)));
};
export default ButtonAtom;
const buttonStyle = style({
    color: stylesSet[ButtonStyleTypes.ActiveA].color,
    background: stylesSet[ButtonStyleTypes.ActiveA].background,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '16px',
    borderRadius: '12px',
    padding: '10px 12px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 24,
    height: 36,
    outline: 'none',
    border: 'none',
    $nest: {
        '&:hover': {
            textDecoration: 'none',
        },
        '&:focus': {
            textDecoration: 'none',
        },
        '& > span': {
            color: stylesSet[ButtonStyleTypes.ActiveA].color,
        },
    },
});
const iconedButtonStyle = style({
    padding: '6px 12px',
    border: 'none',
    cursor: 'pointer',
    $nest: {
        '&:focus': { outline: '0!important;' },
    },
});
const iconStyle = style({
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    $nest: {
        '& + span': {
            marginLeft: 6,
        },
    },
});
//# sourceMappingURL=ButtonAtom.js.map